export const whatIsContent = {
  title: 'What Is Sugargoo Spreadsheet?',
  description: 'A Sugargoo Spreadsheet is a carefully curated and structured collection of product discoveries, shopping resources, category breakdowns, and buying intelligence designed to help international shoppers navigate the Sugargoo platform with confidence and efficiency. Rather than spending countless hours manually searching through listings, users can leverage these organized spreadsheets to instantly access verified product links, compare prices across categories, understand sizing charts, and make informed purchasing decisions. Whether you are hunting for the latest sneaker releases, trending streetwear, high-quality replicas, or unique accessories, the Sugargoo Spreadsheet transforms chaotic browsing into a streamlined, data-driven shopping experience.',
  comparisonRows: [
    { feature: 'Product Discovery', traditional: 'Scattered & Manual', spreadsheet: 'Organized & Instant' },
    { feature: 'Research Time', traditional: 'Hours Per Session', spreadsheet: 'Minutes Per Category' },
    { feature: 'Price Comparison', traditional: 'Tab-by-Tab Browsing', spreadsheet: 'Side-by-Side Tables' },
    { feature: 'Quality Verification', traditional: 'Unreliable Sources', spreadsheet: 'Community-Verified Links' },
    { feature: 'Beginner Friendliness', traditional: 'Steep Learning Curve', spreadsheet: 'Simple & Intuitive' },
    { feature: 'Update Frequency', traditional: 'Static Listings', spreadsheet: 'Regular Fresh Updates' },
  ],
};

export const whyUseCards = [
  {
    icon: 'ri-search-eye-line',
    title: 'Find Trending Products',
    description: 'Instantly discover what the Sugargoo community is currently buying, from viral streetwear pieces to hidden gem accessories that are trending across social media and shopping forums.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Compare Categories',
    description: 'Browse through well-organized product categories with detailed breakdowns, making it effortless to compare different styles, brands, and price points side by side.',
  },
  {
    icon: 'ri-funds-line',
    title: 'Understand Pricing',
    description: 'Get transparent pricing insights across different sellers and quality tiers, helping you budget smarter and avoid overpaying for products available at better rates.',
  },
  {
    icon: 'ri-time-line',
    title: 'Save Research Time',
    description: 'Cut your product research from hours to minutes. Our pre-organized spreadsheets eliminate the need to manually comb through endless listings and forum threads.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Learn Shipping Methods',
    description: 'Access comprehensive shipping method comparisons, estimated delivery timelines, and cost breakdowns so you can choose the optimal shipping strategy for your order.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Avoid Beginner Mistakes',
    description: 'Benefit from community wisdom and curated guides that help newcomers avoid common pitfalls in sizing, quality selection, warehouse management, and customs declarations.',
  },
];

export const reviewContent = {
  title: 'Sugargoo Review: Is It Worth Using?',
  pros: [
    'Access to vast Chinese marketplace inventory at competitive prices',
    'Professional warehouse service with item storage and consolidation',
    'Quality check photos before international shipping',
    'Multiple international shipping carriers with flexible options',
    'User-friendly platform with English interface support',
    'Active community with shared spreadsheets and product finds',
  ],
  cons: [
    'Shipping costs vary significantly based on weight and destination',
    'Learning curve for first-time international shopping agent users',
    'Delivery times depend heavily on chosen shipping method',
    'Quality control photos may not capture every detail',
  ],
  comparisonData: [
    { feature: 'Warehouse Service', sugargoo: 'Yes - Free Storage', traditional: 'Not Available' },
    { feature: 'QC Photos', sugargoo: 'Yes - Included', traditional: 'Limited or None' },
    { feature: 'International Shipping', sugargoo: 'Multiple Carriers', traditional: 'Depends on Seller' },
    { feature: 'Product Consolidation', sugargoo: 'Yes - Combine Orders', traditional: 'Not Available' },
    { feature: 'Spreadsheet Resources', sugargoo: 'Community-Curated', traditional: 'None Available' },
  ],
};

export const faqItems = [
  {
    question: 'Is Sugargoo safe to use?',
    answer: 'Yes, Sugargoo is a legitimate and well-established shopping agent that has been operating for years. They provide buyer protection, secure payment processing through recognized platforms, and maintain transparent communication throughout the ordering and shipping process. However, users should always exercise standard online shopping precautions and verify product listings carefully before purchasing.',
  },
  {
    question: 'How long does Sugargoo shipping take?',
    answer: 'Sugargoo shipping times vary significantly depending on the chosen shipping method and destination country. Express carriers like DHL and FedEx typically deliver within 5-10 business days, while economy lines such as EMS or SAL can take 15-30 business days. Sea freight options are available for larger shipments but may take 30-60 days. Always check the estimated delivery window for your specific route before selecting a shipping method.',
  },
  {
    question: 'Does Sugargoo have a warehouse?',
    answer: 'Yes, Sugargoo operates a warehouse facility where purchased items are received, inspected, and stored. The warehouse team takes quality control photos of each item upon arrival, allowing buyers to verify the condition before international shipping. Items can be stored for a reasonable period, and multiple orders can be consolidated into a single shipment to save on shipping costs.',
  },
  {
    question: 'Are there Sugargoo coupons or discount codes available?',
    answer: 'Sugargoo periodically offers promotional coupons, shipping discounts, and seasonal deals. New users can often find welcome discounts, and returning customers may access loyalty rewards or event-based promotions. It is recommended to check the official Sugargoo announcements and community channels for the latest discount opportunities before placing large orders.',
  },
  {
    question: 'How does the Sugargoo Spreadsheet help me shop better?',
    answer: 'The Sugargoo Spreadsheet is a community-driven resource that compiles verified product links, seller ratings, size charts, and pricing comparisons into organized tables. Instead of searching blindly, you can browse categorized collections of popular finds that have been vetted by experienced users. This drastically reduces research time, helps you avoid low-quality sellers, and enables smarter purchasing decisions based on real community feedback and data.',
  },
];